import Layout from "components/foundation/Layout";
import AboutUsHero from "components/platform/AboutUsHero";
import MeetTheTeam from "components/platform/MeetTheTeam";
import JoinUsSection from "components/platform/JoinUsSection";
import { CTASection } from "components/platform/CTASection";
import { ReactElement } from "react";

const About: NextPageTypes.NextPageWithLayout = () => (
  <main className="">
    <AboutUsHero />
    <MeetTheTeam />
    <JoinUsSection />
    <CTASection className="bg-gray-100" />
  </main>
);

About.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout title="Humanloop – About us" xlWidth>
      {page}
    </Layout>
  );
};

export default About;
